import React, { useState, useEffect } from "react";
import { Flex, Text, Button, useColorModeValue, useToast, Switch } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import useProfileService from "services/profileService"; 

export default function Notifications(props) {
  const { ...rest } = props;
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const toast = useToast();
  const { postQuoteRequest } = useProfileService();

  const [quoteData, setQuoteData] = useState({
    seminaireScientifique: false,
    webinairesAnalyseScenarios: false,
    moduleEvaluationAdditionnel: false,
    journeeCoaching: false,
    animationManagers: false,
  });

  const handleSwitchChange = (id) => {
    setQuoteData(prevData => {
      const newData = { ...prevData, [id]: !prevData[id] };
      return newData;
    });
  };

  useEffect(() => {
  }, [quoteData]);

  const handleSubmitQuote = async () => {
    try {
      const response = await postQuoteRequest(quoteData);
    } catch (error) {
      
    }
  };

  return (
    <Card mb="0px" mt="0px" mx="auto" maxW="410px" {...rest}>
      <Flex align="center" w="100%" justify="space-between" mb="20px">
        <Text color={textColorPrimary} fontWeight="bold" fontSize="2xl" mb="14px">
          Prestation sur mesure
        </Text>
      </Flex>
      {Object.entries(quoteData).map(([key, value]) => (
        <Flex key={key} align="center" mb="25px">
          <Switch
            isChecked={value}
            onChange={() => handleSwitchChange(key)}
            id={key}
          />
          <Text ml="10px">{getLabelForKey(key)}</Text>
        </Flex>
      ))}
      <Button
        me='100%'
        mb='20px'
        w='240px'
        minW='140px'
        mt={{ base: "10px", "2xl": "auto" }}
        variant='brand'
        fontWeight='500'
        onClick={handleSubmitQuote}
      >
        Demander un devis
      </Button>
    </Card>
  );
}

function getLabelForKey(key) {
  const labels = {
    seminaireScientifique: "Séminaire scientifique",
    webinairesAnalyseScenarios: "Webinaires analyse des scénarios",
    moduleEvaluationAdditionnel: "Module d'évaluation additionel",
    journeeCoaching: "Journée de coaching collectif",
    animationManagers: "Conception de scénario sur-mesure",
  };
  return labels[key] || key;
}
